import React from 'react';
import { TpPromptTaskContext, TpTaskFormData, TpTaskFormElemDef, TpTaskFormParsedElemData } from './interfaces';
import { ElemValueWrapper } from '../helpers/ElemValueWrapper';

import styles from './../TaskForm.module.scss';

function setInitialData(elemDef: any, ctx: TpPromptTaskContext, formData: TpTaskFormData) {
  formData.elemValues[elemDef.id] = elemDef.defaultValue;
}

function addSpecificSchema(schema: any): any {
  schema.properties.choices = {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        id: { type: 'string', description: 'Unique identifier of this choice in the list' },
        name: { type: 'string', description: 'Displayed name of this choice' },
      },
      required: ['id', 'name'],
    },
  };
  schema.required.push('choices');
}

function generate(
  elemDef: any,
  ctx: TpPromptTaskContext,
  formData: TpTaskFormData,
  updateElemValue: (elemId: string, newValue: any) => void,
) {
  const choices = elemDef.choices as { id: string; name: string }[];
  return (
    <ElemValueWrapper elemName={elemDef.displayName}>
      <div className={styles.pickList}>
        {choices.map((choice) => (
          <div
            key={choice.id}
            className={choice.id == formData.elemValues[elemDef.id] ? styles.pickListItemSelected : styles.pickListItem}
            onClick={() => {
              updateElemValue(elemDef.id, choice.id);
            }}
          >
            {choice.name}
          </div>
        ))}
      </div>
    </ElemValueWrapper>
  );
}

function parseElemValue(ctx: TpPromptTaskContext, elemDef: any, input: any): TpTaskFormParsedElemData {
  if (elemDef.required && (input === null || input === undefined || input === '')) {
    return { value: null, errorString: 'Missing required field' };
  }
  return {
    value: input,
    errorString: null,
  };
}

const taskFormElemMultipleChoiceDef: TpTaskFormElemDef = {
  type: 'multipleChoice',
  name: 'Multiple Choice',
  description: 'Displays a pick list with a set of predefined choices.',
  hasData: true,
  addSpecificSchema,
  setInitialData,
  generate,
  parseElemValue,
};

export default taskFormElemMultipleChoiceDef;
